export default __webpack_public_path__ + "static/media/ri_arrow-right-s-line.b4f87fd4.svg";